import { lamejsWorker as worker } from './lamejs-worker'

export const convertToMp3IfVideo = async (file: File) => {
  if (file.type.includes('video') && !file.type.includes('webm')) {
    console.log('Converting to mp3', file.type)
    const mp3Buffer = await extractAudioFromVideoFile(file)
    console.log('Converted to mp3')
    return new Blob([mp3Buffer], { type: 'audio/mp3' })
  }
  return new Blob([await file.arrayBuffer()], { type: file.type })
}

export const extractAudioFromVideoFile = async (videoFile: File) => {
  const videoElement = document.createElement('video')
  videoElement.src = URL.createObjectURL(videoFile)

  const sampleRate = 44100
  await new Promise((resolve) => (videoElement.onloadedmetadata = resolve))

  const offlineAudioContext = new OfflineAudioContext({
    numberOfChannels: 1,
    length:
      sampleRate *
      ((videoElement.duration === Infinity ? 7200 : videoElement.duration) ||
        7200),
    sampleRate: sampleRate,
  })

  const audioContext = new AudioContext()
  const videoAsBuffer = await videoFile.arrayBuffer()
  const audioData = await audioContext.decodeAudioData(videoAsBuffer)
  const soundSource = offlineAudioContext.createBufferSource()
  soundSource.buffer = audioData
  soundSource.connect(offlineAudioContext.destination)
  soundSource.start()
  const renderedBuffer = await offlineAudioContext.startRendering()

  const channelData = renderedBuffer.getChannelData(0)
  const renderedBufferSampleRate = renderedBuffer.sampleRate

  const mp3Blob: Blob = await new Promise((resolve) => {
    worker.onmessage = function (e: MessageEvent<Blob>) {
      resolve(e.data)
    }
    worker.postMessage({
      channelData: channelData,
      sampleRate: renderedBufferSampleRate,
    })
  })

  URL.revokeObjectURL(videoElement.src)
  return mp3Blob
}
